module.exports = __webpack_public_path__ + "8795aba0285584aa63e1030f88b008ef.svg";